export default {
  unitLabel: {
    potential: 'Potenciál C/N',
    nitridingToCarbon: 'kN/kC',
    content: 'Obsah C/N',
    depth: 'Hĺbka',
    hardness: 'Tvrdosť',
    carbDepth: 'Hĺbka cementácie',
  },
  profile: {
    carbonProfile: 'Profil uhlíka',
    nitrogenProfile: 'Profil dusíka',
    carbideProfile: 'Profil karbidov',
  },
  legendLabel: 'Legenda',
};
